






























import Vue from "vue";
import { HeaderState } from "@tt-app/models/exercise";

interface Props {
  header: HeaderState;
}

export default Vue.extend<Props>({
  name: "ExerciseHeaderTitle",
  functional: true,
  props: {
    header: { type: Object as () => HeaderState, required: true }
  }
});
